import { render, staticRenderFns } from "./SubprocessDialog.vue?vue&type=template&id=24cf0743&scoped=true&"
import script from "./SubprocessDialog.vue?vue&type=script&lang=js&"
export * from "./SubprocessDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubprocessDialog.vue?vue&type=style&index=0&id=24cf0743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cf0743",
  null
  
)

export default component.exports